import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PlayIcon } from 'lucide-react';
import { heroLogos } from './data';
export function Hero() {
  return <section id="top" className="relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-28" data-id="element-66">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 rounded-full border border-ink/15 bg-white/50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-ink/70" data-id="element-68">
          <span className="h-1.5 w-1.5 rounded-full bg-signal" data-id="element-69" />
          Every marketing & sales signal. One source of truth.
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.05
      }} className="mt-8 max-w-[16ch] font-display text-[13vw] font-semibold leading-[0.92] tracking-tight sm:text-7xl md:text-8xl lg:text-[8.5rem]" data-id="element-70">
          Stop stitching <span className="italic text-signal" data-id="element-71">data.</span> Start
          reading the signal.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.15
      }} className="mt-8 max-w-xl text-lg text-ink/70 md:text-xl" data-id="element-72">
          oursignals unifies HubSpot, GA4, Google Ads, Meta Ads, Salesforce and
          a dozen more tools into a single live feed — so your whole team sees
          attribution, intent, pipeline and spend in real time.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.25
      }} className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-73">
          <a href="#cta" className="group inline-flex items-center justify-center gap-2 rounded-full bg-signal px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-signal-dark" data-id="element-74">
            Start free
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-75" />
          </a>
          <a href="#showcase" className="inline-flex items-center justify-center gap-2 rounded-full border border-ink/20 px-7 py-4 text-base font-semibold text-ink transition-colors hover:bg-ink hover:text-cream" data-id="element-76">
            <PlayIcon className="h-4 w-4" data-id="element-77" />
            Book a demo
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-16 border-t border-ink/10 pt-8" data-id="element-78">
          <p className="text-xs font-semibold uppercase tracking-widest text-ink/40" data-id="element-79">
            Connects with
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-80">
            {heroLogos.map(logo => <span key={logo} className="font-display text-lg font-medium text-ink/50" data-id="element-81">
                {logo}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}